type GroupLike = {
  group_value: ReadonlyArray<{ auth_id: string }>;
};

export function isAuthIdInOrgGroups(
  authId: string | null | undefined,
  groups: ReadonlyArray<GroupLike> | null | undefined,
): boolean {
  if (!authId || !authId.trim() || !groups?.length) return false;

  return groups.some((group) =>
    group.group_value.some((user) => user.auth_id === authId),
  );
}
